module.exports = __webpack_public_path__ + "static/media/table.4564a888.svg";